module.exports = __webpack_public_path__ + "static/media/ramen_curry.e5f77a45.jpg";